import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import VueGtag from "vue-gtag"

Vue.use(VueRouter)

let routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },

  // {
  //   path: '/abehirosuke',
  //   name: 'AbeHirosuke',
  //   meta: { scrollToTop: true },
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "abehirosuke" */ '../components/abehirosuke.vue')
  // },
  // {
  //   path: '/imaichitatsuya',
  //   name: 'ImaichiTatsuya',
  //   meta: { scrollToTop: true },
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "imaichitatsuya" */ '../components/imaichitatsuya.vue')
  // },
  // {
  //   path: '/iwasakinanami',
  //   name: 'IwasakiNanami',
  //   meta: { scrollToTop: true },
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "iwasakinanami" */ '../components/iwasakinanami.vue')
  // },
  // {
  //   path: '/kiibunpei',
  //   name: 'KiiBunpei',
  //   meta: { scrollToTop: true },
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "kiibunpei" */ '../components/kiibunpei.vue')
  // },
  // {
  //   path: '/kudoukazuhiko',
  //   name: 'KudouKazuhiko',
  //   meta: { scrollToTop: true },
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "kudoukazuhiko" */ '../components/kudoukazuhiko.vue')
  // },
  // {
  //   path: '/kuroiwamio',
  //   name: 'KuroiwaMio',
  //   meta: { scrollToTop: true },
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "kuroiwamio" */ '../components/kuroiwamio.vue')
  // },
  // {
  //   path: '/shimizuyuto',
  //   name: 'ShimizuYuto',
  //   meta: { scrollToTop: true },
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "shimizuyuto" */ '../components/shimizuyuto.vue')
  // },
  // {
  //   path: '/joechang',
  //   name: 'JoeChang',
  //   meta: { scrollToTop: true },
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "joechang" */ '../components/joechang.vue')
  // },
  // {
  //   path: '/tsunodaakitoshi',
  //   name: 'TsunodaAkioshi',
  //   meta: { scrollToTop: true },
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "tsunodaakitoshi" */ '../components/tsunodaakitoshi.vue')
  // },
  // {
  //   path: '/dohiyurika',
  //   name: 'DohiYurika',
  //   meta: { scrollToTop: true },
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "dohiyurika" */ '../components/dohiyurika.vue')
  // },
  // {
  //   path: '/hibinojunko',
  //   name: 'HibinoJunko',
  //   meta: { scrollToTop: true },
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "hibinojunko" */ '../components/hibinojunko.vue')
  // },
  // {
  //   path: '/kliopeng',
  //   name: 'KlioPeng',
  //   meta: { scrollToTop: true },
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "kliopeng" */ '../components/kliopeng.vue')
  // },

  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

if(process.env.NODE_ENV === 'development') {
  routes.push(
    {
      path: '/mid',
      name: 'Home-mid',
      component: Home,
    },

    {
      path: '/post',
      name: 'Home-post',
      component: Home,
    },
  );
}

// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
// const scrollBehavior = function (to, from, savedPosition) {
//   if (savedPosition) {
//     // savedPosition is only available for popstate navigations.
//     return savedPosition
//   } else {
//     const position = {}

//     // scroll to anchor by returning the selector
//     if (to.hash) {
//       position.selector = to.hash

//       // specify offset of the element
//       // if (to.hash === '#exhibition') {
//       //   setTimeout(() => {
//       //     scrollTo(0, 1000);
//       //   }, 200);
//       // }

//       // bypass #1number check
//       // if (/^#\d/.test(to.hash) || document.querySelector(to.hash)) {
//       //   return position
//       // }

//       // if the returned position is falsy or an empty object,
//       // will retain current scroll position.
//       return false
//     }

//     return new Promise(resolve => {
//       // check if any matched route config has meta that requires scrolling to top
//       if (to.matched.some(m => m.meta.scrollToTop)) {
//         // coords will be used if no selector is provided,
//         // or if the selector didn't match any element.
//         position.x = 0
//         position.y = 0
//       }

//       // wait for the out transition to complete (if necessary)
//       this.app.$root.$once('triggerScroll', () => {
//         // if the resolved position is falsy or an empty object,
//         // will retain current scroll position.
//         resolve(position)
//       })
//     })
//   }
// }

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  // scrollBehavior,
  routes
})

Vue.use(VueGtag, {
  config: { id: "UA-164934664-1" },
  pageTrackerTemplate(to) {
    return {
      page_title: to.name,
      page_path: process.env.BASE_URL.replace(/\/$/, '') + to.path
    }
  }
},router);

export default router
